import React from "react";
//Limitless imports
import { useAppVisibilityContext } from "../app-visibility/AppVisibilityContext";
/**
 * Temp hook until we port LLM/CRUI to full hooks arch
 */
export const useCreateMessage = errorMessage => {
    const [loading, setLoading] = React.useState(false);
    const { toggleAppOpen } = useAppVisibilityContext();

    React.useEffect(() => {
        if (loading && errorMessage) {
            setLoading(false);
        }
    }, [errorMessage]);

    return {
        toggleAppOpen,
        loading,
        setLoading
    };
};
